<template>
    <div>
        <div v-for="(action, index) in resultRow.actions">
            <p v-if="index !== 0">
                <i>en</i>
            </p>

            <p>
                <trigger-text-field-with-edit v-model="action.description"
                                              :api="`/api/trigger-actions/${action.id}`"
                                              field="description"
                >
                    {{ nl2br(action.description) }}
                    <b-button variant="light" @click="$bvModal.show(`trigger_action_${action.id}`)" size="sm" class="p-0 m-0 ml-1 d-inline-block">
                        <font-awesome-icon icon="circle-question" class="text-secondary"/>
                    </b-button>
                </trigger-text-field-with-edit>
            </p>

            <b-modal :id="`trigger_action_${action.id}`">
                <pre>{{ action.parameters }}</pre>
            </b-modal>
        </div>
    </div>
</template>

<script>
import TriggerTextFieldWithEdit from "@/views/Triggers/FrontendFilterEventResultColumnValues/TriggerTextFieldWithEdit.vue";

export default {
    name: "TriggerActionsView",
    components: {TriggerTextFieldWithEdit},

    props: {
        resultRow: {required: true},
    },

    mounted() {
        this.resultRow.actions = this.resultRow.actions
            .map(action => {
                action.description = action.description ?? action.action_component_display_name
                return action
            })
    },

    computed: {

    }
}
</script>
